import { render, staticRenderFns } from "./CompBusinessYearSelect.vue?vue&type=template&id=68fa76d7&scoped=true&"
import script from "./CompBusinessYearSelect.vue?vue&type=script&lang=js&"
export * from "./CompBusinessYearSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa76d7",
  null
  
)

export default component.exports